import { useState } from 'react';
import { api, ApiRequestError, setAccessToken } from '../api/client.js';
import type { LoginResponse, SessionUser } from '../api/types.js';

/**
 * Anmeldung.
 *
 * Die Meldung bei einem Fehlschlag kommt unveraendert vom Server und unterscheidet
 * bewusst nicht zwischen unbekannter Adresse und falschem Passwort.
 */
export function LoginForm({
  onLogin,
}: {
  onLogin: (user: SessionUser) => void;
}): React.JSX.Element {
  const [email, setEmail] = useState('mueller@haendler-nord.de');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent): Promise<void> {
    event.preventDefault();
    setBusy(true);
    setError(null);
    try {
      const result = await api.post<LoginResponse>('/api/auth/login', {
        email,
        password,
      });
      setAccessToken(result.accessToken);
      onLogin(result.user);
    } catch (e) {
      setError(
        e instanceof ApiRequestError ? e.message : 'Die API ist nicht erreichbar.',
      );
    } finally {
      setBusy(false);
    }
  }

  return (
    <form className="card login" onSubmit={submit}>
      <h2>Anmeldung</h2>
      <label htmlFor="email">E-Mail</label>
      <input
        id="email"
        type="email"
        autoComplete="username"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
        required
      />
      <label htmlFor="password">Passwort</label>
      <input
        id="password"
        type="password"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />
      {error !== null && <p role="alert">{error}</p>}
      <button type="submit" className="primary" disabled={busy}>
        {busy ? 'Wird geprueft …' : 'Anmelden'}
      </button>
    </form>
  );
}
